import { useApiItems } from './useApiItems';
import { Customer } from '../customers/dto/Customer';
import { ApiPath } from '../enums/ApiPath';

export function useCustomers() {
  return useApiItems<Customer>(ApiPath.Customers);
}
